import React from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useQuery } from "@tanstack/react-query";

const useUser = (user = null) => {
  const authUser = user === null ? auth.currentUser : user;

  const FetchData = async () => {
    const match = authUser.email.match(/\+(.*?)@/);
    const pan = match[1].toUpperCase();
    console.log(pan);

    const docRef = doc(db, "usersTable", pan);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      throw new Error("No such User Found!");
    }
    if (!docSnap.data()) {
      throw new Error("User data is undefined");
    }
    const userdata = docSnap.data();

    const itrworkRef = doc(db, "itrWorking", pan);
    const itrworkdocSnap = await getDoc(itrworkRef);

    // Check if the document exists before trying to access its data
    const itrworkData = itrworkdocSnap.exists() ? itrworkdocSnap.data() : {};

    const currentYear = new Date().getFullYear();
    // Calculate the current, previous, and next assessment years
    const currentAY = `${currentYear}-${currentYear + 1}`;
    const previousAY = `${currentYear - 1}-${currentYear}`;

    // Safely access incomeFromSalaries with proper fallbacks
    const incomeSalary = itrworkData[currentAY]?.incomeFromSalaries || 0;

    return { userdata, incomeSalary, itrworkData };
  };
  
  const {
    data: userData,
    isLoading,
    isError,
    error,
  } = useQuery(["User", authUser?.uid], FetchData, { 
    initialData: {},
    enabled: !!authUser?.uid // Only run the query if we have a user ID
  });
  
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  if (isError) {
    console.log("Error", error);
    throw new Error(error);
  }

  return userData;
};

export default useUser;